import React from 'react'
import { withStyles } from '@weareroam/cake-ui-v1/styles'
import withRoot from '../withRoot'

import { RoamLogo as Logo, RoamDots } from '../assets/svg'

const styles = theme => ({
    mobileLogo: {
        display: 'none',
        transform: 'translateY(-5px)',

        '& path': {
            fill: theme.palette.icons.white
        }
    },
    desktopLogo: {
        display: 'block',
    },
    [theme.screens.small]: {
        mobileLogo: {
            display: 'block',
        },
        desktopLogo: {
            display: 'none',
        }
    }
})

class RoamLogo extends React.Component {

    render() {
        const { classes } = this.props

        return (
            <div>
                <div className={classes.mobileLogo}><RoamDots /></div>
                <div className={classes.desktopLogo}><Logo /></div>
            </div>
        )
    }
}

export default withRoot(withStyles(styles)(RoamLogo))



// WEBPACK FOOTER //
// ./src/components/RoamLogo.js